import { DynamicControl, ControlConfiguration } from '@anecdotes/dynamic-form';
import { ToggleBoxComponent } from '../components/toggle-box/toggle-box.component';

export class ToggleBoxControl extends DynamicControl<ToggleBoxComponent, any, any, boolean> {
  constructor(config: ControlConfiguration<any, any, boolean>) {
    super(config, ToggleBoxComponent);
  }

  setValue(
    value: boolean,
    options: {
      onlySelf?: boolean;
      emitEvent?: boolean;
      emitModelToViewChange?: boolean;
      emitViewToModelChange?: boolean;
    } = {}
  ): void {
    super.setValue(value, options);
  }
}
